import { css } from '@emotion/react';
import { EditorAppearance } from '@atlaskit/editor-core/editor';
import { FullWidthToggle } from './FullWidthToggle';
import { token } from '@atlaskit/tokens';
import EditIcon from '@atlaskit/icon/glyph/edit';

const breadcrumbWrapper = css`
  color: ${token('color.text')};
  cursor: default;
`;

const wrapper = css`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  justify-content: space-between;
`;

const miscActionsWrapper = css`
  flex: auto 0;
  align-content: end;
`;

interface BreadcrumbActionsProps {
  appearance: EditorAppearance;
  onFullWidthChange?: (fullWidthMode: boolean) => void;
  toggleEditMode?: (editMode: boolean) => void;
}

export const actionButton = css`
  cursor: pointer;
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: ${token('color.text')};

  &:hover {
    background-color: ${token('color.background.neutral.hovered')};
  }

  &:focus {
    background-color: ${token('color.background.neutral.pressed')};
`;

export const BreadcrumbActions = ({
  toggleEditMode,
  appearance,
  onFullWidthChange
}: BreadcrumbActionsProps) => {
  return (
    <div css={wrapper}>
      <div css={breadcrumbWrapper} id="breadcrumb">
        {'Confluence / Demo / Editor'}
      </div>
      <div css={miscActionsWrapper}>
        {toggleEditMode && (
          <button css={actionButton} onClick={() => toggleEditMode(true)}>
            <EditIcon label="Edit this page" />
          </button>
        )}
        {onFullWidthChange && (
          <FullWidthToggle
            appearance={appearance}
            onFullWidthChange={onFullWidthChange}
          />
        )}
      </div>
    </div>
  );
};
